export default "__VITE_ASSET__D50bADr0__"